<div>
  @switch (iconType) {
    @case ('Pickup') {
      <span class="addressSVG">
        <span class="addressSVG__icon addressSVG__icon--pickup"></span>
      </span>
    }
    @case ('DineIn') {
      <span class="addressSVG">
        <span class="addressSVG__icon addressSVG__icon--dinein"></span>
      </span>
    }
    @case ('Home') {
      <span class="addressSVG" [class.disabled]="!enabled">
        <span class="addressSVG__icon addressSVG__icon--home"></span>
      </span>
    }
    @case ('Work') {
      <span class="addressSVG" [class.disabled]="!enabled">
        <span class="addressSVG__icon addressSVG__icon--work"></span>
      </span>
    }
    @default {
      <span class="addressSVG" [class.disabled]="!enabled">
        <span class="addressSVG__icon addressSVG__icon--location"></span>
      </span>
    }
  }
</div>
